import React, { useEffect, useMemo, useState } from "react";
import AppleLogin from 'react-apple-login'
import { APPLE_APP_ID } from "../constants";
import { useUser } from "../hooks/useApi";
import useLanguage, { T } from "../hooks/useLanguage";
import Button from "./basic/Button";
import Loader from "./basic/Loader";
import { isIOS } from 'react-device-detect';
import { prepareEntryIntentForCurrentLocation } from "../features/entryFlow/entryIntentStorage";

export default function AppleButton({ enabled = true }) {
  const { i18n } = useLanguage();
  const { login, mutation } = useUser();

  const [errorMessage, setErrorMessage] = useState("");
  const useE2EAuthMocks = process.env.REACT_APP_E2E_AUTH_MOCKS === "true";

  // Random per-session state/nonce: protects the Apple OAuth round-trip against
  // CSRF (state) and id_token replay (nonce) instead of using fixed values.
  const oauthState = useMemo(() => window.crypto.randomUUID(), []);
  const oauthNonce = useMemo(() => window.crypto.randomUUID(), []);

  const responseApple = (response) => {
    if (response?.error) {
      setErrorMessage(i18n.t('home.appleerror'));
      return;
    }

    if (response?.authorization?.id_token) {
      if (!response?.user?.email) {
        const jwt = response.authorization.id_token;
        const base64Url = jwt.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        const parsedPayload = JSON.parse(jsonPayload);
        response.user = {
          email: parsedPayload.email,
          name: {
            firstName: parsedPayload?.is_private_email ? "Private apple" : parsedPayload.email.split('@')[0],
            lastName: ''
          }
        };
      }
      const dataToSend = {
        email: response?.user?.email ?? "",
        name: response?.user?.name?.firstName ?? "",
        oauthid: response.authorization.code,
        oauth: response.authorization.id_token,
        state: response?.authorization?.state ?? oauthState,
        picture: "",
        type: "apple",
      };
      login(dataToSend);
    }
  };

  useEffect(() => {
    console.log("errorMessage sideEffects", errorMessage);
    if (errorMessage !== "") {
      setTimeout(() => {
        setErrorMessage("");
      }, 3500);
    }
  }, [errorMessage]);

  if (useE2EAuthMocks) {
    return (
      <Button
        onClick={() => {
          prepareEntryIntentForCurrentLocation();
          login({
            email: "apple.e2e@example.com",
            name: "Apple E2E",
            oauthid: "apple-e2e-code",
            oauth: "apple-e2e-token",
            picture: "",
            type: "apple",
          });
        }}
        className="apple"
        disabled={mutation?.isLoading || !enabled}
      >
        <T>home.loginapple</T>
      </Button>
    );
  }

  return (
    <>
      {isIOS && (
        <AppleLogin
          clientId={APPLE_APP_ID}
          redirectURI="https://millsonicbox.com"
          autoload="false"
          scope={"name email"}
          state={oauthState}
          nonce={oauthNonce}
          callback={responseApple}
          usePopup={true}
          render={(renderProps) => (
            <div>
              <Button
                onClick={(event) => {
                  prepareEntryIntentForCurrentLocation();
                  renderProps.onClick(event);
                }}
                className="apple"
                disabled={renderProps.disabled || !enabled}
                autoload="false"
              >
                <div>
                  {mutation?.isLoading ? <Loader /> : <T>home.loginapple</T>}
                </div>
              </Button>
              {errorMessage !== "" ? (
                <div className="facebook-error-msg">{errorMessage}</div>
              ) : null}
            </div>
          )}
        />
      )}
    </>
  );
}
